//@ts-nocheck
import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';
import LoadingIndicator from 'app/components/LoadingIndicator';

const AMOUNT_KEYS = [
  'supplyAmount',
  'vatAmount',
  'taxFreeAmount',
  'serviceAmount',
];

const OpenUiPage = () => {
  const location = useLocation();
  const [scriptLoaded, setScriptLoaded] = useState(false); // 스크립트 로드 상태 관리
  const url = new URL(`${window.location.origin}${window.location.pathname}`);

  const queryObject = useMemo(() => {
    const params = new URLSearchParams(location.search);
    const obj = {};
    const amount = {};

    params.forEach((value, key) => {
      if (AMOUNT_KEYS.includes(key)) {
        amount[key] = value;
      } else {
        obj[key] = value;
      }
    });

    const hasAnyAmountField = AMOUNT_KEYS.some(
      key => amount[key] !== undefined && amount[key] !== '',
    );

    if (hasAnyAmountField) {
      obj.amount = {
        supplyAmount: amount.supplyAmount ?? '',
        vatAmount: amount.vatAmount ?? '',
        taxFreeAmount: amount.taxFreeAmount ?? '',
        serviceAmount: amount.serviceAmount ?? '',
      };
    }

    return obj;
  }, [location.search]);

  const openPaymentUi = () => {
    if (window.payVerse && typeof window.payVerse.requestUI === 'function') {
      window.payVerse.requestUI(queryObject);
    }
  };

  // 스크립트가 로드되었는지 확인하는 함수
  const checkScriptLoaded = () => {
    if (window.payVerse && typeof window.payVerse.requestUI === 'function') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    // 스크립트가 로드되었는지 확인
    const interval = setInterval(() => {
      if (checkScriptLoaded()) {
        clearInterval(interval); // 스크립트 로드 확인되면 interval 해제
        setScriptLoaded(true); // 상태 업데이트
      }
    }, 100); // 100ms마다 체크 (상황에 맞게 조정 가능)

    return () => clearInterval(interval); // cleanup
  }, []);

  useEffect(() => {
    if (!scriptLoaded) return;
    openPaymentUi();
    window.history.replaceState(null, '', url);
  }, [scriptLoaded, queryObject]);

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100vh',
      }}
    >
      <LoadingIndicator />
    </div>
  );
};

export default OpenUiPage;
